import React from 'react';
import TextField from '@material-ui/core/TextField';

const FormField = ({label, label_exclaim, name, error, touched, onChange, onBlur, autoComplete, placeholder = null, maxLength, readOnly, ...props}) => {

    if(props['type'] === 'date'){ /** @see https://v3.material-ui.com/demos/pickers/#date-pickers */
        props = {
            InputLabelProps :{ // forces placeholder : label above input doesnt lower into "input-value", if value is empty
                shrink: true,
            }, ...props,
        };
    }

    if(props.prefix) {
        props.inputProps = {...props.inputProps, prefix: props.prefix};
    }
    if(props.suffix) {
        props.inputProps = {...props.inputProps, suffix: props.suffix};
    }
    if(props.mask) {
        props.inputProps = {...props.inputProps, type: props.mask};
    }

    return (
        <TextField
            id={name}
            name={name}
            label={label}
            placeholder={placeholder ? placeholder : label}
            onChange={onChange}
            onBlur={onBlur}
            error={touched && !!error}
            helperText={(touched && error) || label_exclaim}
            autoComplete={autoComplete ? autoComplete : 'auto_complete_' + name + Math.random()}
            inputProps={{
                ...props.inputProps,
                maxLength: maxLength || 255,
                readOnly: readOnly,
            }}
            {...props}
        />
    );
};

FormField.defaultProps = {
    fullWidth: true,
};

export default FormField;
